import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MAINTENANCE_ROUTE } from './maintenance.model';
import { MaintenanceService } from './maintenance.service';

export const maintenanceGuard: CanActivateFn = (_route, state) => {
  const maintenanceService = inject(MaintenanceService);
  if (!maintenanceService.active()) {
    return true;
  }
  maintenanceService.setReturnUrl(state.url);
  return inject(Router).createUrlTree(['/', MAINTENANCE_ROUTE]);
};

export const maintenancePageGuard: CanActivateFn = () =>
  inject(MaintenanceService).active() || inject(Router).createUrlTree(['/']);
